exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sampleModal_dialog .sampleModalPicContainer {\n  text-align: center;\n  margin-top: 16px; }\n  .sampleModal_dialog .sampleModalPicContainer img {\n    width: 487px;\n    height: 290px; }\n", ""]);

// exports
